import gql from 'graphql-tag';
import moveIqEstimate from './moveiq-estimate';

const NAME = 'moveIqEstimateRequest';
const FRAGMENT = `fragment ${NAME} on MoveIqEstimateRequest {
  id
  moveId
  estimates {
    ...${moveIqEstimate.name}
  }
}
${moveIqEstimate.fragment}
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
